import { Hima360LogoSVG } from "./Hima360LogoSVG";
export default Hima360LogoSVG;